import { createDismissedFlag } from "./createDismissedFlag";

const STORAGE_KEY = "libertify_upgrade_card_dismissed";

export const upgradeCardCookie = createDismissedFlag(STORAGE_KEY);
